//import logo from './logo.svg';
import './App.css';
import logo from './assets/img/STIU_logo_300.png'

import React, { Component } from 'react';
import { BrowserRouter } from "react-router-dom";
//import { Routes, Route, Switch } from "react-router";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useParams
} from "react-router-dom";

import Aux from './hoc/Aux_';
import JobTitle from './containers/JobTitle/JobTitle';
import Program from './containers/Program/Program';


function App() {
  return (
    <div className="App">
      {/*<header className="App-header"></header>*/}
      <img  src={logo} alt="logo"/>
      <h3>Employability Survey Helper</h3>
      {/*
      <div className="instructions">
        <p>How to use this helper:</p>
        <ol>
          <li>Select the question corresponding to the question from the survey.</li>
          <li>Start typing the answer to the question from the survey into the field below.</li>
          <li>Select the most appropriate option from the list that appears.</li>
          <li>Click on the "Copy" button.</li>
          <li>Return to the survey form and paste your selection into the textfield for that 
            question (Ctrl+V shortcut or by right-clicking in textfield and selecting "Paste").</li>
        </ol>
      </div>
      */}
      <Router>
          <Routes>
            <Route exact path="/" element={<JobTitle/>}/>
            <Route exact path="/jobtitle" element={<JobTitle/>}/>
            <Route exact path="/program" element={<Program/>}/>
            <Route path="*" element={<JobTitle/>}/>
          </Routes>
        </Router>
    </div>
  );
}

export default App;